export default function PageHeader(props) {
    return (
        <div className="container-fluid row bg-primary pageHeader">
            <div className="col-1"></div>
            <div className="col display-2 text-white p-5 ms-5"><span className="headText">{props.title}</span></div>
        </div>
    );
}